var _defs, _rect, _rect2, _circle, _g, _g2, _g3, _circle2, _path, _circle3, _path2, _circle4, _path3, _circle5, _path4, _circle6, _path5, _circle7, _path6, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSapBtpEnterpriseArchitecture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 520",
    width: 700,
    height: 520,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "centerGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a8fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a2e68",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cloudGrad",
    cx: "50%",
    cy: "40%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2ba8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a63ce"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "nodeGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 22,
    height: 22,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "#7fdbff",
    opacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 520,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 520,
    fill: "url(#dots)",
    opacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 260,
    r: 200,
    fill: "url(#centerGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.85;0.5",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "350 260"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 350 260",
    to: "360 350 260",
    dur: "18s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 260,
    r: 190,
    fill: "none",
    stroke: "#4db8ff",
    strokeWidth: 1,
    strokeDasharray: "8 14",
    opacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "350 260"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 350 260",
    to: "0 350 260",
    dur: "12s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 260,
    r: 140,
    fill: "none",
    stroke: "#4db8ff",
    strokeWidth: 1,
    strokeDasharray: "5 10",
    opacity: 0.22
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#4dcfff",
    strokeWidth: 1.8,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 260,
    x2: 350,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 260,
    x2: 590,
    y2: 118
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 260,
    x2: 590,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 260,
    x2: 350,
    y2: 452
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 260,
    x2: 110,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 260,
    x2: 110,
    y2: 118
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#7ee7ff",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path-top"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-top",
    d: "M350,260 L350,60",
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#7ee7ff",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path-topright"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-topright",
    d: "M350,260 L590,118",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#7ee7ff",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path-bottomright"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path-bottomright",
    d: "M350,260 L590,400",
    fill: "none"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#7ee7ff",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path-bottom"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path-bottom",
    d: "M350,260 L350,452",
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#7ee7ff",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "1.6s"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "1.6s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path-bottomleft"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path-bottomleft",
    d: "M350,260 L110,400",
    fill: "none"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#7ee7ff",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "2.0s"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "2.0s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path-topleft"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path-topleft",
    d: "M350,260 L110,118",
    fill: "none"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softGlow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 350,
    cy: 255,
    rx: 115,
    ry: 80,
    fill: "#0a63ce",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.22;0.1",
    dur: "4s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 290 C240 290 220 270 220 246 C220 226 235 208 257 204 C268 176 296 156 330 156 C367 156 398 178 408 210 C438 212 461 235 461 263 C461 291 438 313 410 313 L280 313 C271 313 265 303 265 290Z",
    fill: "url(#cloudGrad)",
    stroke: "#7ee7ff",
    strokeWidth: 3,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.6;1;0.6",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 341,
    y: 243,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Arial Black, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 40,
    letterSpacing: -1
  }, "SAP"), /*#__PURE__*/React.createElement("text", {
    x: 341,
    y: 294,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Arial Black, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 38,
    letterSpacing: 1
  }, "BTP"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(268, 18)",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 72,
    rx: 14,
    fill: "#071e4a",
    stroke: "#4dcfff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.4;1;0.4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 18,
    fill: "#0a63ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 39 C15 39 12 36 12 32 C12 28 15 24 19 24 C21 17 28 13 36 13 C42 13 47 17 48 23 C52 24 55 28 55 33 C55 38 51 42 46 42 L21 42 Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(6, 18) scale(0.65)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 30,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Integration"), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 47,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Suite"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 80)",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 72,
    rx: 14,
    fill: "#071e4a",
    stroke: "#4dcfff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.4;1;0.4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.33s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 18,
    fill: "#0a63ce"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    width: 7,
    height: 7,
    rx: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27,
    width: 7,
    height: 7,
    rx: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 36,
    width: 7,
    height: 7,
    rx: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36,
    width: 7,
    height: 7,
    rx: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 30,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Cloud &amp;"), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 47,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Applications"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(510, 80)",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 72,
    rx: 14,
    fill: "#071e4a",
    stroke: "#4dcfff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.4;1;0.4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.66s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 18,
    fill: "#0a63ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 28 L28 44 M20 36 L36 36",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 6,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 10,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 30,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "API"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 47,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Management"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(510, 368)",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 72,
    rx: 14,
    fill: "#071e4a",
    stroke: "#4dcfff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.4;1;0.4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 18,
    fill: "#0a63ce"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 29,
    r: 4,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 29,
    r: 4,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 42,
    r: 4,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 29,
    x2: 31,
    y2: 29,
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 33,
    x2: 26,
    y2: 38,
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 33,
    x2: 30,
    y2: 38,
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 30,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Event"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 47,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "Mesh"))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(268, 432)",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 72,
    rx: 14,
    fill: "#071e4a",
    stroke: "#4dcfff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.4;1;0.4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.33s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 18,
    fill: "#0a63ce"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 5,
    height: 10,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 30,
    width: 5,
    height: 16,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 5,
    height: 22,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 28,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 11
  }, "Analytics &amp;"), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 45,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 11
  }, "Intelligence"))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 368)",
    filter: "url(#nodeGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 72,
    rx: 14,
    fill: "#071e4a",
    stroke: "#4dcfff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.4;1;0.4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.66s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 18,
    fill: "#0a63ce"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 36,
    r: 4,
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 36,
    r: 4,
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 30,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "S/4"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 47,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 12
  }, "HANA"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#7ee7ff",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 130,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 390,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 175,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 345,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 175,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 345,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapBtpEnterpriseArchitecture);
export default __webpack_public_path__ + "static/media/sap-btp-enterprise-architecture.471815c9a193c8cec4fddffb0f95a266.svg";
export { ForwardRef as ReactComponent };